import { EGroupsActions, GroupsActions } from './groups.actions';
import { IGroupsState, initialGroupsState } from './groups.state';
import { IGroup } from '@interfaces/IGroup';

export const groupsReducers = (
  state = initialGroupsState,
  action: GroupsActions
): IGroupsState => {
  switch (action.type) {
    case EGroupsActions.GetGroup:
      return {
        ...state,
        loading: { ...state.loading },
      };
    case EGroupsActions.RequestAllGroups:
      return {
        ...state,
        loading: { ...state.loading, allGroups: true },
      };
    case EGroupsActions.GetGroupSuccess:
      return {
        ...state,
        selectedGroup: action.group,
        loading: { ...state.loading },
      };
    case EGroupsActions.ResetErrors:
      return {
        ...state,
        errors: {
          createGroup: {},
        },
      };
    case EGroupsActions.GetGroups:
      return {
        ...state,
        loading: {
          ...state.loading,
          allGroups: true,
        },
      };
    case EGroupsActions.GetGroupsSuccess:
      return {
        ...state,
        errors: {
          createGroup: {},
        },
        groupsArray: action.groups,
        loading: { ...state.loading, allGroups: false },
        groups: getOrderedGroups(action.groups),
      };
    case EGroupsActions.GetGroupsFailure:
      return {
        ...state,
        loading: { ...state.loading, allGroups: false },
        errors: { ...state.errors, getGroups: action.errors },
      };
    default:
      return { ...state };
  }
};

const getOrderedGroups = (groups: IGroup[]) => {
  const orderedGroups: { [key: number]: IGroup[] } = {};

  groups.map(group => {
    if (orderedGroups[group.course]) {
      orderedGroups[group.course].push(group);
    } else {
      orderedGroups[group.course] = [group];
    }
    orderedGroups[group.course].sort(
      (a: IGroup, b: IGroup) => a.number - b.number
    );
  });

  return orderedGroups;
};
